import store from '../store'

export const setLoading = () => {
    store.commit('SET_LOADING')
}

export const removeLoading = () => {
    store.commit('REMOVE_LOADING')
}